import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import { combineReducers } from 'redux';
import dashboard from './Dashboard';
import lcopsReducers from '../components/lcops/reducers';
import lockerReducers from '../components/locker/reducers';
import authznReducers from '../components/authzn/reducers';
import dbServiceReducers from '../components/dbservice/reducers';
import crepoReducers from '../components/crepo/reducers';

const rootReducer = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    dashboard,
    ...lcopsReducers(),
    ...lockerReducers(),
    ...authznReducers(),
    ...dbServiceReducers(),
    ...crepoReducers()
  });

export default rootReducer;
